export const iconFontAwesomeGamingDiceD6 = (
	<i className="fa-solid fa-dice-d6"></i>
);
